/**
 * queryLimit
 * Return an integer value suitable for use in an API query's limit clause.
 * See STCOR-616, STCOR-617 for suggested improvements.
 */
export default () => 2000;
